import { useMemo } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { LANGS } from "@/lib/langs";

export const LangSelect = ({ value, onChange, allowAuto = true, testId }) => {
  const options = useMemo(() => LANGS.filter((l) => allowAuto || l.code !== "auto"), [allowAuto]);
  return (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger className="h-11 rounded-none font-mono text-sm" data-testid={testId}>
      <SelectValue />
    </SelectTrigger>
    <SelectContent className="max-h-72">
      {options.map((l) => (
        <SelectItem key={l.code} value={l.code} data-testid={`${testId}-option-${l.code}`}>
          <span className="mr-2 font-mono text-xs text-muted-foreground">[{l.code.toUpperCase()}]</span>
          {l.name}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
};
